<template>
  <!--        选择框模式-->
  <el-cascader
      v-if="type === 'select'"
      ref="J_CASCADER_DOM"
      :clearable="clearable"
      class="j-cascader-wrap"
      v-model="cascaderArr"
      :options="treeData"
      :separator="textSeparator"
      :props="{ ...props, ...labelValue, multiple }"
      v-bind="$attrs"
      @change="changeEvent" />
  <!--        文本模式-->
  <span v-else class="j-cascader-text">
      <template v-if="multiple">
        {{String(value).split(separator).map(item => getTextByMap(item, treeMap, textSeparator)).join(separator)}}
      </template>
      <template v-else>
        {{getTextByMap(value, treeMap, textSeparator)}}
      </template>
    </span>
</template>

<script>
import Vue from 'vue'
import mixins from "@/components/JComponents/JCascader/mixins";
export default {
  name: "JCascader",
  mixins: [mixins],
  props: {
    tree: {
      type: Array,
      default: null
    },
    code: {
      type: String
    },
    props: {
      type: Object,
      default: () => {
        return { checkStrictly: false }
      }
    },
    multiple: { //  是否多选
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    value: {
      type: [String, Number, Array]
    },
    separator: {
      // 多选时多个选项间的分隔符
      type: String,
      default: ','
    },
    textSeparator: {
      // 文本模式分隔符
      type: String,
      default: '/'
    },
    type: {
      // select为选择框模式，text或不传未文本解析模式
      type: String,
      default: 'text'
    },
    valueType: { // String/Array 多选时返回类型
      type: String,
      default: 'String'
    }
  },
  watch: {
    type () {
      this.updateData()
      this.updateSelect(this.value)
    },
    value (nv) { this.updateSelect(nv) },
    multiple () { this.updateSelect(this.value) },
    code () { this.updateData() },
    tree () { this.updateData() }
  },
  data () {
    return {
      treeMap: {},
      treeData: [],
      cascaderArr: []
    }
  },
  created () {
    this.updateData()
    this.updateSelect(this.value)
  },
  methods: {
    updateData () {
      if (this.tree) {
        const map = {}
        this.treeData = this.tree
        this.treeRecursionMap(this.treeData, map, this.labelValue)
        this.treeMap = map
        return
      }
      if (this.hasStore()) return this.injectStore()
      console.warn(`JCascader解析失败，未注册JCascader Store`)
    },
    updateSelect (value) {
      if (this.type === 'select') {
        if (this.valueType === 'Array') {
          return this.cascaderArr = value
        }
        if (!value && value !== 0) return  this.cascaderArr = []
        if (this.multiple) {
          const array = String(value).split(this.separator)
          return this.cascaderArr = array.map(arr => arr.split(this.textSeparator))
        }
        this.cascaderArr = String(value).split(this.textSeparator)
      }
    },
    changeEvent (arr) {
      if (this.valueType === 'Array') {
        return this.$emit('input', arr)
      }
      if (this.multiple) {
        if (arr.length === 0) return this.$emit('input', '')
        return this.$emit('input', arr.map(array => this.handleValue(array)).join(this.separator))
      }
      this.$emit('input', this.handleValue(arr))
    },
    async injectStore () {
      if (!this.code) return console.warn(`JCascader加载失败，缺少code参数`)
      if (Vue.store.state.JCascader.Tree[this.code]) {
        this.treeData = Vue.store.state.JCascader.Tree[this.code] || []
        this.treeMap = Vue.store.state.JCascader.Map[this.code] || {}
      } else {
        const { tree, map } = await Vue.store.dispatch('JCascader/getCascaderTreeByKey', this.code)
        this.treeData = tree || []
        this.treeMap = map || {}
      }
    },
    hasStore () {
      return Vue.store && Vue.store.state.JCascader
    },
    handleValue (array) {
      return array.join(this.textSeparator)
    }
  }
}
</script>

<style>
.j-cascader-wrap {
  width: 100%;
}
</style>